module.exports = __webpack_public_path__ + "img/Infografis_EN_22.ddc31d9b.jpg";